import { componentQrl, inlinedQrl, _jsxC, Slot, _IMMUTABLE, _fnSignal } from "@builder.io/qwik";
import { getBlockActions } from "../../../functions/get-block-actions.qwik.mjs";
import { getBlockProperties } from "../../../functions/get-block-properties.qwik.mjs";
import { DynamicRenderer } from "../../dynamic-renderer/dynamic-renderer.qwik.mjs";
const BlockWrapper = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  return /* @__PURE__ */ _jsxC(DynamicRenderer, {
    get TagName() {
      return props.Wrapper;
    },
    actionAttributes: getBlockActions({
      block: props.block,
      rootState: props.context.rootState,
      rootSetState: props.context.rootSetState,
      localState: props.context.localState,
      context: props.context.context,
      stripPrefix: true
    }),
    attributes: getBlockProperties({
      block: props.block,
      context: props.context
    }),
    children: /* @__PURE__ */ _jsxC(Slot, null, 3, "87_0"),
    [_IMMUTABLE]: {
      TagName: _fnSignal((p0) => p0.Wrapper, [
        props
      ], "p0.Wrapper")
    }
  }, 1, "87_1");
}, "BlockWrapper_component_kOI0j0aW8Nw"));
export {
  BlockWrapper,
  BlockWrapper as default
};
